
export function performCleanup(
  form: HTMLFormElement,
  imageToRemove: any,
  audioToRemove: any,
  imageHandling: any,
  voiceRecording: any
): void {
  setTimeout(() => {
    try {
      form.reset();
      if (imageToRemove) {
        imageHandling.handleImageChange(null);
      }
      if (audioToRemove) {
        voiceRecording.recordedAudioRef.current = null;
      }
    } catch (cleanupError) {
      console.warn("Erreur nettoyage (non critique):", cleanupError);
    }
  }, 200);
}
